import { createContext } from 'react';

export type IMetadataContext = Record<string, string>;

export const DefaultMetadataContext: IMetadataContext = {};

const MetadataContext = createContext(DefaultMetadataContext);

export default MetadataContext;
